<template>
  <el-dialog v-if="columnList" :title="title" @closed="_closed" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="top5" top="5vh" width="50%">
    <el-row>
      <l-table :option="tableOption" :data="columnList">
        <template slot="visible" slot-scope="scope">
          <el-switch v-model="scope.row.visible" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </template>
      </l-table>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancle">取 消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      title: '', // 内置参数,误删
      visible: true, // 内置参数,误删
      dataInfo: null,
      columnList: null,
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 280 + 'px',
        columns: [
          { label: '序号', type: 'index' },
          { label: '栏目编号', prop: 'code' },
          { label: '栏目名称', prop: 'label' },
          { label: '操作', slot: 'visible' }
        ]
      }
    }
  },
  mounted() {
    this.getColumnList()
  },
  methods: {
    getColumnList() {
      this.columnList = this.$constant.ecarListColumn.get(this.dataInfo.enterpriseCode, this.dataInfo.userId)
    },
    save() {
      this.$lgh.msgConfirm('确认保存配置信息?', () => {
        var arr = []
        this.columnList.forEach(a => {
          if (a.visible) arr.push(a.code)
        })
        this.$constant.ecarListColumn.set(this.dataInfo.enterpriseCode, this.dataInfo.userId, arr)
        this.visible = false
        this.onsuccess && this.onsuccess(this.dataInfo)
      })
    }
  }
}
</script>

<style></style>
